/**
 * Project: Academy V2
 * File: PlayIcon.tsx
 * Author: Colopi Salvatore
 * Author URI: https://salvatorecolopi.com
 * Created: Tue Jun 04 2024 at 19:39:47
 *
 * Copyright (c) 2024 Edusogno. All rights reserved.
 */

import React from "react";
const PlayIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
    <svg
    width={11}
    height={14}
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.335938 0.583984V13.4173L10.4193 7.00065L0.335938 0.583984Z"
      fill="#8065C9"
    />
  </svg>
);

export default PlayIcon;
